import { colors } from '@vst/beam';

const Divider = (): JSX.Element => {
  return <div style={{ borderBottom: `1px solid ${colors['gray'][200]}` }} />;
};

export default Divider;
